import { useUserContext } from "../../components/contexts/useUserContext"
import {Container, ProfileCard, BookingCard} from "./styles"
import UserPlaceholder from '../../assets/user-placeholder.png'
import Button from '../../components/Button'
import { Link } from "react-router-dom"
import { useState } from "react"
import { photo } from "../../../src/services/photo"

function ClientProfile() {
    const { user } = useUserContext()
    const [image, setImage] = useState(`${photo.defaults.baseURL + user.client_image_url}`)

    
    return (
        <>        
        <Container>
            <div className='title'>
            <h1>Meu perfil</h1>
            <h2>Olá, <span>{user? user.name:''}!</span> </h2>
            </div>
            <ProfileCard>
                <div className='client-info'>
                    <div className='profile-pic'>
                        <img alt="Foto de Perfil" src={user.client_image_url? `${photo.defaults.baseURL + user.client_image_url}`: UserPlaceholder} />
                    </div>
                </div>

                <p className='sub-title'>Informações Pessoais</p>
                <div className="account">
                    <div className='client-account'>
                        <p>Nome</p>
                        <span>{user? user.name:''}</span>
                    </div>
                    <div className='client-info'>
                        <p>E-mail</p>
                        <span>{user? user.email:''}</span>
                    </div>
                    
                    <div className='client-account'>
                        <p>CPF</p>
                        <span>{user.cpf}</span>
                    </div>
                    <div className='client-account'>
                        <p>RG</p>
                        <span>{user.rg}</span>
                    </div>
                </div>

                <p className='sub-title'>Endereço</p>
                <div className="account">
                    <div className='client-account'>
                        <p>DDD</p>
                        <span>{user.ddd}</span>
                    </div>
                    <div className='client-account'>
                        <p>Telefone</p>
                        <span>{user.phone}</span>
                    </div>

                    <div className='client-account'>
                        <p>Cidade</p>
                        <span>{user.city}</span>
                    </div>
                    <div className='client-account'>
                        <p>Estado</p>
                        <span>{user.state}</span>
                    </div>

                    <div className='client-account'>
                        <p>Bairro</p>
                        <span>{user.neighborhood}</span>
                    </div>
                    <div className='client-account'>
                        <p>Rua</p>
                        <span>{user.street}</span>
                    </div>
                </div>

                <div className='custom-button' style={{marginTop: '2rem'}}>
                    <Link to='profile/edit'>
                        <Button format='profile' type='submit'>Editar perfil</Button>
                    </Link>
                </div>
            </ProfileCard>  

            <BookingCard>
                <div className='client-history'>
                    <Button format='profile'>Ver minhas solicitações de reserva</Button>
                </div>
                <div className='client-history'>
                    <Button  format='profile'>Ver histórico de pedidos</Button>
                </div>
            </BookingCard>
        </Container>
        </>
    )
}

export default ClientProfile